import { css } from '@emotion/css';
import { LichSuPhienModel, SumResult, TableStatsType } from 'models/gameModel';
import { useEffect, useRef, useState } from 'react';
import { convertSumResult } from 'utils/common';

const interfaceTable: any = [
    ['', '', '', '', '', '', '', '', ''],
    ['', '', '', '', '', '', '', '', ''],
    ['', '', '', '', '', '', '', '', ''],
    ['', '', '', '', '', '', '', '', ''],
    ['', '', '', '', '', '', '', '', ''],
    ['', '', '', '', '', '', '', '', ''],
];

const interfaceTableMobile = [
    ['', '', '', '', '', '', ''],
    ['', '', '', '', '', '', ''],
    ['', '', '', '', '', '', ''],
    ['', '', '', '', '', '', ''],
    ['', '', '', '', '', '', ''],
    ['', '', '', '', '', '', ''],
];

interface IItemCau {
    id: number;
    row: number;
    col: number;
    str: string;
    session_id: number;
    clsLineTop?: string;
    clsLineBottom?: string;
    clsLineLeft?: string;
    clsLineRight?: string;
    isDirection?: boolean;
}

interface ITblCau {
    row: IItemCau[];
}

interface Props {
    issueList: LichSuPhienModel[];
    rowSetting: number;
    colSetting: number;
    typeStats: TableStatsType;
    issueUpdate: LichSuPhienModel | undefined;
    isMobile?: boolean;
    height?: number;
}
export default function TableCau(props: Props) {
    const { issueList, rowSetting, colSetting, typeStats, issueUpdate, isMobile, height } = props;
    const arrCauRef = useRef<any[]>([]);

    const [tblCau, setTblCau] = useState<ITblCau[]>(isMobile ? interfaceTableMobile : interfaceTable);

    useEffect(() => {
        if (issueList?.length > 0) {
            initTblCauChart(issueList);
        }
    }, [issueList]);

    useEffect(() => {
        if (issueUpdate) {
            const issueTemp: IItemCau = { id: issueUpdate.id, session_id: issueUpdate.session_id, str: '', row: 0, col: 0 };

            issueTemp.str = generateLabel(issueUpdate.result);
            arrCauRef.current.push(issueTemp);
            arrCauRef.current = groupObjectDubInArr(arrCauRef.current, false);
            setColRowIssueDuplicate();
        }
    }, [issueUpdate]);

    const initTblCauChart = (issueData: LichSuPhienModel[]) => {
        //reset data
        setTblCau([]);
        arrCauRef.current = [];

        issueData = issueData.slice(0, 50);

        for (let i = 0; i < issueData.length; i++) {
            let issue = issueData[i];
            //init issue Item position
            const issueTemp: IItemCau = { id: issue.id, session_id: issue.session_id, str: '', row: 0, col: 0 };

            issueTemp.str = generateLabel(issue.result);
            arrCauRef.current.push(issueTemp);
        }

        arrCauRef.current = groupObjectDubInArr(arrCauRef.current);

        setColRowIssueDuplicate();
    };

    const generateLabel = (result: number[]) => {
        const sum = result.reduce((accumulator, currentValue) => accumulator + currentValue, 0);

        if (typeStats === 'NUMBER') {
            return String(convertSumResult(sum));
        } else if (typeStats === 'CHANLE') {
            return sum % 2 === 0 ? 'C' : 'L';
        } else if (typeStats === 'TAIXIU') {
            if (convertSumResult(sum) > 2) return 'T';
            else if (convertSumResult(sum) < 2) return 'X';
            else return '2';
        } else if (typeStats === 'TAIXIU_TX') {
            if (result.every((value) => value === result[0])) return 'B';
            else if (sum >= 11) return 'T';
            else return 'X';
        } else if (typeStats === 'CHANLE_TX') {
            if (result.every((value) => value === result[0])) return 'B';
            return sum % 2 === 0 ? 'C' : 'L';
        }
        return '';
    };

    const setColRowIssueDuplicate = () => {
        arrCauRef.current.map((arrIssue: IItemCau[], idxCol: number) => {
            arrIssue.map((issue: IItemCau, idxRow: number) => {
                issue.row = idxRow;
                issue.col = idxCol;
                issue.clsLineBottom && delete issue.clsLineBottom;
                issue.clsLineLeft && delete issue.clsLineLeft;
                issue.clsLineRight && delete issue.clsLineRight;
                issue.clsLineTop && delete issue.clsLineTop;

                return issue;
            });

            return arrIssue;
        });

        checkCollideRowCol();
    };

    const checkCollideRowCol = () => {
        // console.log('arrCauRef---->', JSON.parse(JSON.stringify(arrCauRef.current)));

        const cloneArrCauList: IItemCau[] = [];

        for (let idxCol = 0; idxCol < arrCauRef.current.length; idxCol++) {
            const arrIssue: IItemCau[] = arrCauRef.current[idxCol];
            let countColItemNgang = 1;
            let collideRowCol = rowSetting - 1;
            let flagCheckCollide = false;

            for (let idxIssue = 0; idxIssue < arrIssue.length; idxIssue++) {
                const issue = arrIssue[idxIssue];
                if (cloneArrCauList.length > 0 && !flagCheckCollide) {
                    const findPointCollide = cloneArrCauList.find((point: IItemCau) => point.row === issue.row && point.col === issue.col);
                    if (findPointCollide) {
                        if (findPointCollide.row > 0) {
                            collideRowCol = findPointCollide.row - 1;
                        } else {
                            //insert col empty to hack col when collideRow = 0;
                            arrCauRef.current.splice(idxCol, 0, []);

                            //update col to new if collideRow = 0
                            arrCauRef.current.slice(idxCol + 1).map((arrNewCol: IItemCau[]) => {
                                arrNewCol.map((newIssue) => {
                                    newIssue.col += 1;
                                    return newIssue;
                                });
                                return arrNewCol;
                            });
                            break;
                        }
                        flagCheckCollide = true;
                    }
                }

                //bẻ line trái->phải
                if (issue.row > collideRowCol) {
                    issue.row = collideRowCol;
                    issue.col += countColItemNgang;
                    arrIssue[idxIssue - 1].isDirection = true;
                    countColItemNgang += 1;
                } else {
                    countColItemNgang = 1;
                }
                cloneArrCauList.push(issue);
            }
        }

        renderColRow(cloneArrCauList);
    };

    const renderColRow = (cloneArrCauList: IItemCau[]) => {
        arrCauRef.current = groupObjectDubInArr(cloneArrCauList, false);
        arrCauRef.current.map((arrIssue: IItemCau[], idxCol: number) => {
            const checkDirectionLine = arrIssue.find((issue) => issue.isDirection);
            if (checkDirectionLine) {
                arrIssue.map((issue: IItemCau, idxIssue: number) => {
                    if (issue.row <= checkDirectionLine.row && issue.col === checkDirectionLine.col) {
                        issue.clsLineTop = 'lineTop';
                        issue.clsLineBottom = 'lineBottom';
                        if (issue.row === checkDirectionLine.row) {
                            delete issue.clsLineBottom;
                            issue.clsLineRight = 'lineRight';
                        }
                    } else {
                        issue.clsLineLeft = 'lineLeft';
                        issue.clsLineRight = 'lineRight';
                        if (arrIssue.length - 1 === idxIssue) {
                            delete issue.clsLineRight;
                        }
                    }
                    return issue;
                });
            }
        });

        //gom các nhóm mảng thành 1 mảng duy nhất
        arrCauRef.current = arrCauRef.current.flat();

        // thụt lùi col khi vượt quá col được chọn
        const maxItemCol = arrCauRef.current.reduce((max, item) => (item.col > max.col ? item : max), arrCauRef.current[0]);
        let maxCol = maxItemCol.col - colSetting + 1;
        arrCauRef.current.map((item) => {
            item.col -= maxCol;
            return item;
        });

        const arrTblCau: any[] = [];
        for (let r = 0; r < rowSetting; r++) {
            const arrRow: IItemCau[] = [];
            const getValRow = arrCauRef.current.filter((item) => item.row === r);
            for (let c = 0; c < colSetting; c++) {
                if (getValRow.length === 0) {
                    arrRow.push({ id: 0, session_id: 0, str: '', row: r, col: c });
                } else {
                    const valCau = getValRow.find((item) => item.col === c);
                    if (valCau) {
                        arrRow.push(valCau);
                    } else {
                        arrRow.push({ id: 0, session_id: 0, str: '', row: r, col: c });
                    }
                }
            }
            arrTblCau.push(arrRow);
        }

        setTblCau(arrTblCau);
    };

    const groupObjectDubInArr = (arr: IItemCau[], isReverse = true) => {
        // nhóm phần từ giống nhau từ trên xuống cuối mảng
        let groupedArray = [];
        let currentGroup = [arr[0]];
        for (let i = 1; i < arr.length; i++) {
            if (arr[i].str === arr[i - 1].str) {
                currentGroup.push(arr[i]);
            } else {
                groupedArray.push(currentGroup);
                currentGroup = [arr[i]];
            }
        }

        // thêm nhóm cuối cùng vào mảng kết quả
        groupedArray.push(currentGroup);

        if (isReverse) {
            groupedArray = groupedArray.reverse();
            groupedArray.map((item) => {
                return swapColRowSort(item.reverse());
            });
        }

        return groupedArray;
    };

    const swapColRowSort = (arr: IItemCau[]) => {
        let left = 0;
        let right = arr.length - 1;

        while (left < right) {
            // Hoán đổi giá trị ở vị trí `left` và `right`
            [arr[left].row, arr[right].row] = [arr[right].row, arr[left].row];
            [arr[left].col, arr[right].col] = [arr[right].col, arr[left].col];

            // Di chuyển chỉ số
            left++;
            right--;
        }

        return arr;
    };

    if (isMobile) {
        return (
            <div className={styles.tableMobile}>
                {tblCau.map((row: any, index) => (
                    <div className="row-item" key={index}>
                        {row.map((col: IItemCau, idx: number) => (
                            <div
                                className={`col-item ${styles.flexColItem(colSetting + 1)} ${typeStats === 'NUMBER' ? '' : 'small'}`}
                                key={idx}
                            >
                                <div className="col-content">
                                    <div className={`issue ${col.str ? 'dot-' + col.str : ''}`}>{col.str}</div>
                                    {col.clsLineTop && <div className="lineTop"></div>}
                                    {col.clsLineBottom && <div className="lineBottom"></div>}
                                    {col.clsLineLeft && <div className="lineLeft"></div>}
                                    {col.clsLineRight && <div className="lineRight"></div>}
                                </div>
                            </div>
                        ))}
                        <div className={`col-item ${styles.flexColItem(colSetting + 1)} ${typeStats === 'NUMBER' ? '' : 'small'}`}>
                            <div className="col-content">
                                <div className="issue"></div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        );
    }
    return (
        <div className={styles.tableWrap}>
            {tblCau.map((row: any, index) => (
                <div className="row-item" key={index}>
                    {row.map((col: IItemCau, idx: number) => (
                        <div className={`col-item ${typeStats === 'NUMBER' ? '' : 'small'}`} key={idx}>
                            <div className={`issue ${col.str ? 'dot-' + col.str : ''}`}>{col.str}</div>
                            {col.clsLineTop && <div className="lineTop"></div>}
                            {col.clsLineBottom && <div className="lineBottom"></div>}
                            {col.clsLineLeft && <div className="lineLeft"></div>}
                            {col.clsLineRight && <div className="lineRight"></div>}
                            {col.session_id !== 0 && <span className="hover-session">#{col.session_id}</span>}
                        </div>
                    ))}
                    <div className={`col-item ${typeStats === 'NUMBER' ? '' : 'small'}`}>
                        <div className="issue"></div>
                    </div>
                </div>
            ))}
        </div>
    );
}

const styles = {
    tableWrap: css`
        padding: 2px;
        background: #e1e1e1;
        .row-item {
            display: flex;
            gap: 1px;
            padding-bottom: 1px;
            .col-item {
                flex: 1;
                height: 24px;
                min-width: 24px;
                background: #141d33;
                border-radius: 4px;
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;
                cursor: initial;
                &:hover {
                    background: #d8d8d8;
                    span {
                        display: block;
                    }
                }
                &.small {
                    width: 14px;
                    height: 14px;
                    min-width: unset;
                    background: #fff;
                    &:hover {
                        background: #b2b2b2;
                        span {
                            display: block;
                        }
                    }
                    .issue {
                        width: unset;
                        height: unset;
                        font-size: 14px;
                        &.dot-2,
                        &.dot-B {
                            width: 12px;
                            height: 12px;
                            font-size: 12px;
                        }
                    }

                    .lineLeft,
                    .lineRight,
                    .lineBottom,
                    .lineTop {
                        background: #9f9f9f;
                    }
                }
                .issue {
                    width: 20px;
                    height: 20px;
                    color: #fff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: 600;
                    border-radius: 24px;

                    &.dot-0 {
                        background: #3f5079;
                    }
                    &.dot-1 {
                        background: #5a75ff;
                    }
                    &.dot-2,
                    &.dot-B {
                        background: #008f76;
                    }
                    &.dot-3 {
                        background: #a86500;
                    }
                    &.dot-4 {
                        background: #ff000f;
                    }
                    &.dot-C,
                    &.dot-X {
                        color: #175ee6;
                    }
                    &.dot-L,
                    &.dot-T {
                        color: #ff0000;
                    }
                }
                .lineLeft,
                .lineRight,
                .lineBottom,
                .lineTop {
                    position: absolute;
                    z-index: 2;
                }
                .lineBottom,
                .lineTop {
                    width: 1px;
                    height: 50%;
                    background: #fff;
                    left: 50%;
                    margin-left: -0.5px;
                }
                .lineTop {
                    top: 0;
                }
                .lineBottom {
                    bottom: 0;
                }
                .lineLeft,
                .lineRight {
                    width: 50%;
                    height: 1px;
                    background: #fff;
                    top: 50%;
                    margin-top: -0.5px;
                }
                .lineLeft {
                    left: 0;
                }
                .lineRight {
                    right: 0;
                }
                .hover-session {
                    position: absolute;
                    top: -20px;
                    left: 0;
                    font-size: 11px;
                    background: red;
                    border-radius: 2px;
                    padding: 2px;
                    display: none;
                    z-index: 3;
                }
            }
        }
    `,

    tableMobile: css`
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        background: #e1e1e1;
        .row-item {
            display: flex;
            padding-bottom: 1px;
            flex: 1;
        }
        .col-item {
            position: relative;
            padding-right: 1px;
            border-radius: 4px;
            &.small {
                .issue {
                    font-size: 10px;
                    font-weight: 700;
                }
                .dot-2,
                .dot-B {
                    font-size: 8px;
                }
            }
            .col-content {
                background: #fff;
                padding: 1px;
                border-radius: 2px;
                height: 100%;
            }
            .issue {
                height: 100%;
                color: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: 600;
                border-radius: 24px;
                font-size: 14px;
                &.dot-0 {
                    background: #3f5079;
                }
                &.dot-1 {
                    background: #5a75ff;
                }
                &.dot-2,
                &.dot-B {
                    background: #008f76;
                }
                &.dot-3 {
                    background: #a86500;
                }
                &.dot-4 {
                    background: #ff000f;
                }
                &.dot-C,
                &.dot-X {
                    color: #175ee6;
                }
                &.dot-L,
                &.dot-T {
                    color: #ff0000;
                }
            }
            .lineLeft,
            .lineRight,
            .lineBottom,
            .lineTop {
                position: absolute;
                z-index: 2;
            }
            .lineBottom,
            .lineTop {
                width: 1px;
                height: 50%;
                background: #9f9f9f;
                left: 50%;
                margin-left: -0.5px;
            }
            .lineTop {
                top: 0;
            }
            .lineBottom {
                bottom: 0;
            }
            .lineLeft,
            .lineRight {
                width: 50%;
                height: 1px;
                background: #9f9f9f;
                top: 50%;
                margin-top: -0.5px;
            }
            .lineLeft {
                left: 0;
            }
            .lineRight {
                right: 0;
            }
        }
    `,
    flexColItem: (num: number) => {
        return css`
            flex: 0 0 calc(100% / ${num});
        `;
    },
    heightColItem: (num: number) => {
        return css`
            height: calc(100% / ${num});
        `;
    },
};
